import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PageHeader, Button, withNameInput, TextInput } from '../components'
import { fields } from '../../common/lib/redux-fields'
import { updateMe } from '../../common/users/actions'
import { clearGroup, getStudentsWithoutGroup } from '../../common/groups/actions'
import { validateCreateGroup } from '../../common/groups/validations'
import formValidation from '../../common/lib/formValidation'

class GroupForm extends React.Component {
  componentDidMount() {
    this.props.getStudentsWithoutGroup()
  }

  componentWillUnmount() {
    const { fields, clearGroup } = this.props
    fields.$reset()
    clearGroup()
  }

  async submitForm(e) {
    e.preventDefault()
    const { fields, submit, history, group } = this.props
    const values = {
      ...fields.$values(),
    }
    if (group) {
      values.id = group.id
    }

    if (await submit(values) !== false) {
      fields.$reset()
      history.push('/app/groups')
    }
  }

  render() {
    const { fields, viewer, group, updateMe, studentsWithoutGroup, intl } = this.props

    const students = studentsWithoutGroup

    return (
      <div className="test-page float-left width-full">
        {/*
          !viewer.seenGuides.groupDescription &&
          <Popup
            title="Inštrukcie"
            text="..."
            onClick={() => updateMe({ seenGuides: { groupDescription: true } })}
          />
        */}
        <form className="flex-column">
          <PageHeader
            title={group ? `${intl.formatMessage(messages.editClass)} ${group.name}` : intl.formatMessage(messages.createClass)}
            button={
              <Button
                positive
                className="float-right disable-spacing-right"
                onClick={(e) => this.submitForm(e)}
              >
                {intl.formatMessage(messages.saveClass)}
              </Button>
            }
          />
          {this.props.errorMessage}
          <TextInput
            {...fields.name}
            label={intl.formatMessage(messages.className)}
            placeholder={intl.formatMessage(messages.enterName)}
          />
          <div className="group-form-students">
            {/*
              TODO pridanie zoznamu studentov cez maily
            */}
            <div className="group-form-students-picker">
              <h3>{intl.formatMessage(messages.yourStudents)}:</h3>
              {
                students && students.length ?
                  students.map(s => (
                    <div key={s.id} className={`student-item ${fields.students.value.find(st => st.id === s.id) ? 'selected-student' : ''}`}>
                      <span>{s.name}</span>
                      {
                        fields.students.value.find(st => st.id === s.id) ?
                          <Button
                            negative
                            onClick={() => {
                              fields.students.onChange({
                                value: fields.students.value.filter(st => s.id !== st.id),
                              })
                            }}
                          >
                            {intl.formatMessage(messages.remove)}
                          </Button>
                        :
                          <Button
                            positive
                            onClick={() => {
                              fields.students.onChange({
                                value: [...fields.students.value, s],
                              })
                            }}
                          >
                            + {intl.formatMessage(messages.add)}
                          </Button>
                      }
                    </div>
                  ))
                :
                  <p>{intl.formatMessage(messages.studentsWillShow)}</p>
              }
            </div>
            <div className="group-form-students-selected">
              <h3>{intl.formatMessage(messages.students)}:</h3>
              {
                fields.students.value.map(student => (
                  <div key={student.id} className="student-item">
                    <span>{student.name}</span>
                    <FontAwesomeIcon
                      className="student-item-icon fa-lg"
                      icon="times-circle"
                      onClick={() => {
                        fields.students.onChange({
                          value: fields.students.value.filter(s => s.id !== student.id),
                        })
                      }}
                    />
                  </div>
                ))
              }
              <p>{intl.formatMessage(messages.studentsCount)}: {fields.students.value.length}</p>
            </div>
          </div>
          <div className="block-center bottom-save-button">
            <Button
              big
              positive
              onClick={(e) => this.submitForm(e)}
            >
              {intl.formatMessage(messages.saveClass)}
            </Button>
          </div>
        </form>
      </div>
    )
  }
}

GroupForm.defaultProps = {
  match: null,
  group: null,
}

GroupForm.propTypes = {
  fields: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
  group: PropTypes.object,
  clearGroup: PropTypes.func.isRequired,
  updateMe: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  errorMessage: PropTypes.any.isRequired,
}

GroupForm = withRouter(GroupForm)

const enhance = compose(
  withNameInput,
  formValidation(props => ({
    validationFunc: validateCreateGroup,
    submitFunc: props.submitGroup,
  })),
  connect(state => ({
    viewer: state.users.viewer,
    studentsWithoutGroup: state.groups.studentsWithoutGroup,
  }), { updateMe, clearGroup, getStudentsWithoutGroup }),
  fields({
    path: 'GroupForm',
    fields: ['name', 'students'],
    getInitialState: props => ({
      name: (props.group && props.group.name) || props.name || '',
      students: (props.group && props.group.students) || [],
    }),
  }),
  injectIntl,
)

export default enhance(GroupForm)

const messages = defineMessages({
  createClass: {
    id: 'group.form.createClass',
    defaultMessage: 'Vytvoriť triedu',
  },
  editClass: {
    id: 'group.form.editClass',
    defaultMessage: 'Upraviť triedu',
  },
  enterName: {
    id: 'group.form.enterName',
    defaultMessage: 'Zadajte názov triedy',
  },
  className: {
    id: 'group.form.className',
    defaultMessage: 'Názov triedy',
  },
  saveClass: {
    id: 'group.form.saveClass',
    defaultMessage: 'Uložiť triedu',
  },
  students: {
    id: 'group.form.students',
    defaultMessage: 'Študenti triedy',
  },
  yourStudents: {
    id: 'group.form.yourStudents',
    defaultMessage: 'Vaši študenti',
  },
  remove: {
    id: 'group.form.remove',
    defaultMessage: 'Odobrať',
  },
  add: {
    id: 'group.form.add',
    defaultMessage: 'Pridať',
  },
  studentsCount: {
    id: 'group.form.studentsCount',
    defaultMessage: 'Počet žiakov',
  },
  studentsWillShow: {
    id: 'group.form.studentsWillShow',
    defaultMessage: 'Tu sa zobrazia študenti, ktorí vyplnili Vaše testy.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/forms/GroupForm.js